import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import MobileMenu from './MobileMenu';
import './MobileNav.css';

const MobileNav = () => {
  const [isMobileOpen, setIsMobileOpen] = useState(false);
  const [isVisible, setIsVisible] = useState(false);

  const closeMobile = () => setIsMobileOpen(false);
  const openMobile = () => setIsMobileOpen(true);

  useEffect(() => {
    document.body.classList.toggle('no-scroll', isMobileOpen);
    return () => document.body.classList.remove('no-scroll');
  }, [isMobileOpen]);

  useEffect(() => {
    const handleScroll = () => {
      const scrollPosition = window.scrollY;
      const isMobile = window.innerWidth <= 768; // Standard Mobile Breakpoint
      
      console.log('Mobile Nav Scroll Debug:', { scrollPosition, isMobile, windowWidth: window.innerWidth }); // Debug log
      
      // Nur auf mobilen Geräten (≤ 768px) aktiv
      if (isMobile) {
        // Navigation zeigen ab 200px, verstecken wenn unter 200px
        // ABER: Wenn das Mobile Menu offen ist, Navigation immer sichtbar lassen
        const shouldShow = scrollPosition >= 200 || isMobileOpen;
        setIsVisible(shouldShow);
        console.log('Mobile Nav - Should show:', shouldShow, 'at scroll position:', scrollPosition, 'menu open:', isMobileOpen); // Debug log
      } else {
        // Auf Desktop/Tablet (> 768px) immer versteckt
        setIsVisible(false);
        console.log('Desktop/Tablet - Mobile Nav hidden'); // Debug log
      }
    };

    // Initial check
    handleScroll();

    // Throttle scroll events für bessere Performance
    let ticking = false;
    const throttledHandleScroll = () => {
      if (!ticking) {
        requestAnimationFrame(() => {
          handleScroll();
          ticking = false;
        });
        ticking = true;
      }
    };

    window.addEventListener('scroll', throttledHandleScroll, { passive: true });
    window.addEventListener('resize', handleScroll);

    return () => {
      window.removeEventListener('scroll', throttledHandleScroll);
      window.removeEventListener('resize', handleScroll);
    };
  }, [isMobileOpen]); // Abhängigkeit hinzugefügt

  return (
    <nav className={`mobile-nav ${isVisible ? 'mobile-nav--visible' : ''}`}>
      <div className="mobile-nav__container">
        <Link to="/" className="mobile-nav__logo" aria-label="Go to homepage">
          <img
            src="/img/nintschew_logo_2.png"
            alt="Nintschew & Partner Logo"
            className="mobile-nav__logo-image"
          />
        </Link>

        <div className="mobile-nav__menu">
          <button className="mobile-nav__hamburger" aria-label="Open menu" onClick={openMobile}>
            <span />
            <span />
            <span />
          </button>
        </div>
      </div>

      <MobileMenu open={isMobileOpen} onClose={closeMobile} />
    </nav>
  );
};

export default MobileNav;
